import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function detailRequestApi (formData) {
  const request = axiosApi().post(
    Constants.TRAHANG_DETAIL_API, 
    formData
  )

  return handleRequest(request);
}

function traHangUpdateRequestApi (formData) {
  const request = axiosApi().post(
    Constants.TRAHANG_UPDATE_API, 
    formData
  )

  return handleRequest(request);
}

function* traHangDetailRequestFlow ({payload, callback}) {
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.traHangDetailSuccess(results.data))
    if (typeof callback === 'function') {
      yield call(callback, results.data)
    }
  } catch (error) {
    yield put(brActions.traHangDetailError(error))
  }
}

function* traHangUpdateRequestFlow ({payload, callback}) {
  try {
    // grab the client from our action
    const result = yield call(traHangUpdateRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.traHangUpdateSuccess(result));
    if (typeof callback === 'function') {
      yield call(callback, result)
    }
  } catch (error) {
    yield put(brActions.traHangUpdateError(error))
  }
}

function* traHangWatcher () {
  yield [
    takeLatest(Constants.TRAHANG_DETAIL_REQUESTING, traHangDetailRequestFlow),
    takeLatest(Constants.TRAHANG_UPDATE_REQUESTING, traHangUpdateRequestFlow),
  ]
}

export default traHangWatcher



// WEBPACK FOOTER //
// ./src/views/TraHang/sagas.js